import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate} from "react-router-dom";
import { Button } from "antd";
import AddIcon from '@mui/icons-material/Add';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import DataProductTable from "../../components/Data-product-table/DataProductTable";
require('firebase/auth')

function ProductList(){

    const [carregando, setCarregando] = useState(1);

    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)

    useEffect(() => {

        if(userLogado > 0) {
            return
        }
        else {
            <Navigate to='/login' />
        }
    },[carregando]);

    return(
        <>
            { 
                useSelector(state => state.usuarioLogado) > 0 ? 
                    <NewMiniDrawer divOpen={
                        <div className="freight-content">
                            <div className="container mb-3">
                                <div className="row">
                                    <div className="col-5">
                                        <h4>Precificação</h4>
                                    </div>
                                    <div className="col-5">
                                    </div>
                                    <div className="col-2">
                                        <div className="col-md-11 control-label">
                                            {user?.permissoes?.product?.isCreate || user?.permissoes?.produto?.cadastrar ? (
                                                <Link to={"/product"}>
                                                    <Button id="ButtonHover" type="primary" icon={<AddIcon />}>
                                                        Novo
                                                    </Button>
                                                </Link>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                </div>        
                            </div>
                            <div>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataProductTable />
                                </div>
                            </div>
                        </div>
                }/>
                : 
                <Navigate to='/login' />
            }
        </>
    );
}

export default ProductList;